import { incomingPostbackApi } from "api/TenantSlug/IncomingPostback/api.ts";

export function composeGetIncomingPostbackQueryOptions(postbackId: string, request?: unknown) {
    return {
        queryKey: ["getIncomingPostback", postbackId, request],
        queryFn: () => incomingPostbackApi.show(postbackId, request),
    };
}

export const getIncomingPostbackQueryOptions = (formStructureId: string, request?: unknown) => {
    return {
        ...composeGetIncomingPostbackQueryOptions(formStructureId, request),
        suspense: true,
    };
};
